(function () {
  'use strict';

  class CamadaValorInformativoCtrl {

    constructor($stateParams, Restangular, $window) {
      this.restangular = Restangular;
      this.window = $window;

      this.link = '';
      this.buscaLink($stateParams.uo);
    }

    navegaLink() {
      this.window.open(this.link, '_blank');
    }

    navegaPlanoSolucoes() {
      this.restangular.one('/auth/app-info').getList().then(data => {
        const urlVfleets = data.find(tipo => tipo.id === 'core-conducaoeconomica').url;
        this.window.open(`${urlVfleets}/planos-solucoes`, '_blank');
      });
    }

    buscaLink(uoId) {
      this.restangular.one(`configuracao/configuracoes/${uoId}/link-portal`).get()
      .then((res) => {
        this.link = res.linkPlanosPortal;
      });
    }
  }

  angular
    .module('camadaValor')
    .controller('CamadaValorInformativoCtrl', CamadaValorInformativoCtrl);
}());
